import type { CacheBackend } from "@pdfking/compatibility"
import type { GUID } from "@pdfking/tfunc"
import { CopyIterable, GenericHash } from "@pdfking/tfunc"

import type { MessageRouter } from "../types/MessageRouter"
import type { ReceiverInput } from "../types/ReceiverInput"
import { CachedForward } from "./CachedForward"

export const HashedCacheForward = <T, R>(
  forward: MessageRouter<T, R>,
  hash?: (input: ReceiverInput<T>) => Promise<GUID>,
  cache?: CacheBackend<R[]>
): MessageRouter<T, R> =>
  CachedForward(
    forward,
    async input => {
      const [stream, shainput] = CopyIterable(input, 2)
      const alg = hash ?? GenericHash
      const key = await alg(shainput)
      return [key, stream]
    },
    cache
  )
